/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Toggle_BalanceInputs */

const vi_movement_breakdown_toggle_balance = /** @type {(inputs: Movement_Breakdown_Toggle_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn`)
};

/**

* @param {Movement_Breakdown_Toggle_BalanceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_toggle_balance = /** @type {((inputs?: Movement_Breakdown_Toggle_BalanceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Toggle_BalanceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_toggle_balance(inputs)
});